import React, { useEffect, useState } from "react";
import { Dna } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "../css/main.css";
import { getCart, getIdPrduct } from "../redux/action";

function ProductId({ setQTY }) {
  const { state } = useLocation();
  const [status, setstatus] = useState(false);

  const dispatch = useDispatch();
  const { Cart } = useSelector((state) => state);
  const { data, loading, error } = useSelector((state) => state.IdPrduct);
  const get = data ?? false;
  useEffect(() => {
    dispatch(getIdPrduct(state));
    Cart.map((item) => {
      if (item._id === state) {
        setstatus(true);
      }
    });
  }, []);
  /////////////////////////////////////////////////// disabled btn
  const qq = Cart.find((item) => item._id === state);
  if (status) {
    if (qq === undefined) {
      setstatus(false);
      setTimeout(() => {
        setQTY(Math.random());
      }, 200);
    }
  }
  return (
    <div className="flex justify-center">
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : error ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-20 flex justify-center w-full sm:w-4/5 text-slate-100">
          <div className="w-full bg-gray-800 m-5 rounded-xl relative shadow-xl">
            <div className="left text-xs md:text-sm xl:text-base 2xl:text-lg m-10 mt-48 sm:mt-5">
              <div className="mt-6 flex justify-start">
                <p>
                  <span className="font-semibold text-teal-500 overflow-auto">
                    Name :
                  </span>
                  {get.name}
                </p>
              </div>
              <div className="mt-6 flex justify-start">
                <p>
                  <span className="font-semibold text-teal-500">Brand : </span>
                  {get.brand}
                </p>
              </div>
              <div className="mt-6 flex justify-start">
                <p>
                  <span className="font-semibold text-teal-500">
                    Category :{" "}
                  </span>
                  {get.category}
                </p>
              </div>
              <div className="mt-6 flex justify-start">
                <p>
                  <span className="font-semibold text-teal-500 relative">
                    Color :
                  </span>
                  {get.color}
                  {
                    <span
                      className="w-5 inline-block ml-2 h-5 rounded-full relative top-2"
                      style={{ backgroundColor: get.color }}
                    ></span>
                  }
                </p>
              </div>
              <div className="mt-6 flex justify-start">
                <p>
                  <span className="font-semibold text-teal-500">Price : </span>
                  {get.price} $
                </p>
              </div>
              <div className="mt-6 flex justify-start">
                <p>
                  <span className="font-semibold text-teal-500">Rating : </span>
                  {get.rating}
                </p>
              </div>
              <div className="mt-6 flex justify-start">
                <p>
                  <span className="font-semibold text-teal-500">
                    CountIn Stock :
                  </span>
                  {get.countInStock == 0
                    ? "There is no inventory"
                    : get.countInStock}
                </p>
              </div>
              <div className="mt-6 flex justify-start">
                <p>
                  <span className="font-semibold text-teal-500">
                    Num Reviews :
                  </span>
                  {get.numReviews}
                </p>
              </div>
              <div className="mt-6 flex justify-start overflow-auto">
                <p>
                  <span className="font-semibold text-teal-500">
                    Description :
                  </span>
                  {get.description}
                </p>
              </div>
            </div>
            <div className="rounded-xl shadow-xl absolute top-5 right-5 w-10/12 sm:w-4/12 2xl:w-3/12 h-40 lg:h-60 2xl:h-64 bg-white flex justify-center items-center overflow-hidden">
              <img className="w-4/12" src={get.image} alt="image" />
            </div>
            <button
              className={`relative bottom-5 btn btn-primary hover:bg-transparent hover:border-4 hover:scale-105 hover:text-violet-300 transition-all duration-300 hover:shadow-xl w-60 ${
                status && "hover:scale-100"
              }`}
              onClick={() => {
                !status && dispatch(getCart("AddProduct", state, get));
                setstatus(true);
                setQTY(Math.random());
              }}
            >
              {!status ? (
                "add to cart"
              ) : (
                <span className="w-full flex justify-between">
                  <span
                    className="btn btn-circle btn-error btn-sm hover:scale-125 text-lg"
                    onClick={() => {
                      dispatch(getCart("MinusNumber", state));
                      setQTY(Math.random());
                    }}
                  >
                    -
                  </span>
                  <span className="text-2xl count">
                    {Cart.map((item) => {
                      if (item._id === state) {
                        return item.qty;
                      }
                    })}
                  </span>
                  <span
                    className="btn btn-circle btn-success btn-sm hover:scale-125 text-lg"
                    onClick={() => {
                      Cart.map((item) => {
                        if (item._id === state) {
                          if (get.countInStock > item.qty) {
                            dispatch(getCart("PlusNumber", state));
                            setQTY(Math.random());
                          }
                        }
                      });
                    }}
                  >
                    +
                  </span>
                </span>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductId;
